import { DateTime } from 'luxon'

export const NETWORK_COMPARISON_MODES = ['previous', 'last_year'] as const
export type NetworkComparisonMode = (typeof NETWORK_COMPARISON_MODES)[number]

export const SAME_WEEKDAYS_MAX_WINDOW_DAYS = 6

const parseDate = (isoDate: string) => DateTime.fromISO(isoDate, { zone: 'utc' })

export function computeWindowDays(periodStart: string, periodEnd: string): number {
  const days = parseDate(periodEnd).diff(parseDate(periodStart), 'days').days
  return Math.max(Math.floor(days) + 1, 1)
}

export function comparisonShiftDays(windowDays: number): number {
  return windowDays <= SAME_WEEKDAYS_MAX_WINDOW_DAYS ? 7 : windowDays
}

export function computeDefaultComparisonPeriod(
  periodStart: string,
  periodEnd: string,
): { compStart: string; compEnd: string } {
  const shiftDays = comparisonShiftDays(computeWindowDays(periodStart, periodEnd))
  return {
    compStart: parseDate(periodStart).minus({ days: shiftDays }).toISODate()!,
    compEnd: parseDate(periodEnd).minus({ days: shiftDays }).toISODate()!,
  }
}

function sameIsoWeekdayLastYear(date: DateTime): string {
  const weekYear = date.weekYear - 1
  const { weeksInWeekYear } = DateTime.fromObject(
    { weekYear, weekNumber: 1, weekday: 1 },
    { zone: 'utc' },
  )
  return date.set({ weekYear, weekNumber: Math.min(date.weekNumber, weeksInWeekYear) }).toISODate()!
}

export function networkComparisonPeriod(
  periodStart: string,
  periodEnd: string,
  mode: NetworkComparisonMode,
): { compStart: string; compEnd: string } {
  if (mode === 'previous') return computeDefaultComparisonPeriod(periodStart, periodEnd)
  return {
    compStart: sameIsoWeekdayLastYear(parseDate(periodStart)),
    compEnd: sameIsoWeekdayLastYear(parseDate(periodEnd)),
  }
}
